import { Component, OnDestroy, OnInit } from "@angular/core";
import { LayoutService } from "../../services/layout.service";
import { AuthenticationService } from "src/app/services/authentication.service";

@Component({
    selector: "app-topbar",
    templateUrl: "./topbar.component.html",
})
export class TopbarComponent implements OnInit, OnDestroy {
    constructor(
        public layoutService: LayoutService,
        private authService: AuthenticationService,
    ) {}

    ngOnInit() {}

    ngOnDestroy() {}

    getName() {
        return this.authService.getClaims()["firstName"];
    }

    showEmail() {
        return this.authService.userProfile !== null;
    }
}
